// Minimal country set. Expand as needed.
export const SUPPORTED_COUNTRIES = [
  { code: 'GB', dialCode: '+44', trunkPrefix: '0' },
  { code: 'IE', dialCode: '+353', trunkPrefix: '0' },
  { code: 'US', dialCode: '+1', trunkPrefix: '' },
  { code: 'FR', dialCode: '+33', trunkPrefix: '0' }
];

export const DEFAULT_COUNTRY_CODE = 'GB';


